<div class="auth-container">
  <div class="auth-sub-container" style="max-width:350px !important;">

    <img
      src="logo.png"
      alt="Wide & Heavy"
      class="logo"
      matTooltip="Wide & Heavy"
    />

    <h1 class="title">Signup</h1>

    @if (!isUserRegistrationEnabled() && !loadingSettings()) {
      <div class="red-container" style="margin:25px 25px 0px 25px;">
        Signup is currently disabled.
        Try again later.
      </div>
    }

    <mat-stepper
      orientation="horizontal"
      [linear]="true"
      #stepper
    >

      <!-- STEP 1 -->

      <mat-step [stepControl]="emailForm" [editable]="false">

        <!-- <ng-template matStepLabel>Email</ng-template> -->

        <form
          [formGroup]="emailForm"
          (ngSubmit)="createEmailToken()"
          autocomplete="off"
        >

          <mat-form-field appearance="outline" class="auth-form-field mt-10" autocomplete="off">

            <mat-label>Email</mat-label>

            <input
              matInput
              formControlName="email"
              type="email"
              placeholder="Enter your email"
              autocomplete="off"
              [readonly]="loading() || !isUserRegistrationEnabled()"
            />

            @if(emailForm.get('email')?.invalid &&
                (emailForm.get('email')?.dirty ||
                emailForm.get('email')?.touched)) {

              <mat-error>
                Invalid email address
              </mat-error>

            }

          </mat-form-field>

          <button
            mat-flat-button
            class="main-button-squared-full-width lightyellow mb-25"
            type="submit"
            [disabled]="emailForm.invalid || loading() || !isUserRegistrationEnabled()"
          >

            @if(!loading()){
              Continue
            } @else {
              <mat-spinner
                diameter="20"
                strokeWidth="3"
              ></mat-spinner>
            }

          </button>

        </form>

      </mat-step>


      <!-- STEP 2 -->

      <mat-step [stepControl]="emailVerifyForm" [editable]="false">

        <!-- <ng-template matStepLabel>Verify</ng-template> -->

        <form
          [formGroup]="emailVerifyForm"
          (ngSubmit)="verifyEmailCode()"
          autocomplete="off"
        >

          <mat-form-field appearance="outline" class="auth-form-field mt-10">

            <mat-label>Email Verification Code</mat-label>

            <input
              matInput
              formControlName="email_code"
              placeholder="Enter verification code"
            />

            @if(emailVerifyForm.get('email_code')?.invalid &&
                (emailVerifyForm.get('email_code')?.dirty ||
                emailVerifyForm.get('email_code')?.touched)) {

              <mat-error>
                Invalid code
              </mat-error>

            }

          </mat-form-field>

          <button
            mat-flat-button
            class="main-button-squared-full-width lightyellow mb-20"
            type="submit"
            [disabled]="emailVerifyForm.invalid || loading() || !isUserRegistrationEnabled()"
          >

            @if(!loading()){
              Continue
            } @else {
              <mat-spinner
                diameter="20"
                strokeWidth="3"
              ></mat-spinner>
            }

          </button>

          <div class="yellow-container mt-10">

            @if(resendEmailCodeTimer() > 0){

              <div>
                Didn't get a code?
                Resend in {{resendEmailCodeTimer()}}
              </div>

            } @else {

              <div>

                Didn't get a code?

                <a
                  matTooltip="Resend"
                  (click)="createEmailToken()"
                >
                  Resend it
                </a>

              </div>

            }

          </div>

        </form>

      </mat-step>


      <!-- STEP 3 -->

      <mat-step [stepControl]="cellPhoneForm" [editable]="false">

        <!-- <ng-template matStepLabel>Phone</ng-template> -->

        <form
          [formGroup]="cellPhoneForm"
          (ngSubmit)="createCellPhoneToken()"
        >

          <mat-form-field appearance="outline" class="auth-form-field mt-10">

            <mat-label>Cell Phone</mat-label>

            <input
              matInput
              formControlName="cell_phone"
              placeholder="Enter phone number"
            />

            @if(cellPhoneForm.get('cell_phone')?.invalid &&
                (cellPhoneForm.get('cell_phone')?.dirty ||
                cellPhoneForm.get('cell_phone')?.touched)) {

              <mat-error>
                Invalid phone number
              </mat-error>

            }

          </mat-form-field>

          <button
            mat-flat-button
            class="main-button-squared-full-width lightyellow mb-25"
            type="submit"
            [disabled]="cellPhoneForm.invalid || loading() || !isUserRegistrationEnabled()"
          >

            @if(!loading()){
              Continue
            } @else {
              <mat-spinner diameter="20"></mat-spinner>
            }

          </button>

        </form>

      </mat-step>


      <!-- STEP 4 -->

      <mat-step [stepControl]="cellPhoneVerifyForm" [editable]="false">

        <!-- <ng-template matStepLabel>SMS</ng-template> -->

        <form
          [formGroup]="cellPhoneVerifyForm"
          (ngSubmit)="verifyCellPhoneCode()"
        >

          <mat-form-field appearance="outline" class="auth-form-field mt-10">

            <mat-label>SMS Code</mat-label>

            <input
              matInput
              formControlName="phone_code"
              placeholder="Enter verification code"
            />

            @if(cellPhoneVerifyForm.get('phone_code')?.invalid &&
                (cellPhoneVerifyForm.get('phone_code')?.dirty ||
                cellPhoneVerifyForm.get('phone_code')?.touched)) {

              <mat-error>
                Invalid code
              </mat-error>

            }

          </mat-form-field>

          <button
            mat-flat-button
            class="main-button-squared-full-width lightyellow mb-20"
            type="submit"
            [disabled]="cellPhoneVerifyForm.invalid || loading() || !isUserRegistrationEnabled()"
          >

            @if(!loading()){
              Continue
            } @else {
              <mat-spinner diameter="20"></mat-spinner>
            }

          </button>

          <div class="yellow-container mt-10">

            @if(resendCellPhoneCodeTimer() > 0){

              <div>
                Didn't get code?
                Resend in {{resendCellPhoneCodeTimer()}}
              </div>

            } @else {

              <div>

                Didn't get code?

                <a
                  (click)="createCellPhoneToken()"
                >
                  Resend it
                </a>

              </div>

            }

          </div>

        </form>

      </mat-step>


      <!-- STEP 5 -->

      <mat-step [stepControl]="userForm" [editable]="false">

        <!-- <ng-template matStepLabel>Finish</ng-template> -->

        <form
          [formGroup]="userForm"
          (ngSubmit)="createUser()"
          autocomplete="off"
        >

          <mat-form-field appearance="outline" class="auth-form-field mt-10" autocomplete="off">
            <mat-label>First Name</mat-label>

            <input
              matInput
              formControlName="first_name"
            />

          </mat-form-field>


          <mat-form-field appearance="outline" class="auth-form-field" autocomplete="off">

            <mat-label>Last Name</mat-label>

            <input
              matInput
              formControlName="last_name"
            />

          </mat-form-field>

          <mat-form-field appearance="outline" class="auth-form-field" autocomplete="off">
            <mat-label>Password</mat-label>

            <input
              matInput
              [type]="hide() ? 'password' : 'text'"
              formControlName="password"
              autocomplete="new-password"
            />

            <button
              mat-icon-button
              matSuffix
              type="button"
              class="mr-7"
              (click)="hide.set(!hide())"
              [attr.aria-label]="hide() ? 'Show password' : 'Hide password'"
              [attr.aria-pressed]="!hide()"
              [matTooltip]="hide() ? 'Show password' : 'Hide password'"
            >
              <mat-icon>{{ hide() ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </mat-form-field>

          <div class="legal-section">

            <mat-checkbox formControlName="accept_terms_of_service">
              I agree to the
              <a routerLink="/pages/terms-of-service" target="_blank" (click)="$event.stopPropagation()">
                Terms of Service
              </a>
            </mat-checkbox>

            <mat-checkbox formControlName="accept_privacy_policy" class="mt-10">
              I agree to the
              <a routerLink="/pages/privacy-policy" target="_blank" (click)="$event.stopPropagation()">
                Privacy Policy
              </a>
            </mat-checkbox>

          </div>

          <button
            mat-flat-button
            class="main-button-squared-full-width lightyellow mb-25"
            type="submit"
            [disabled]="userForm.invalid || loading() || !isUserRegistrationEnabled()"
          >

            @if(!loading()){
              Done
            } @else {
              <mat-spinner diameter="20"></mat-spinner>
            }

          </button>

        </form>

      </mat-step>

    </mat-stepper>

    <div class="bottom-actions">

      <button
        mat-button
        class="danger-button"
        (click)="goToLogin()"
      >
        Cancel
      </button>

    </div>

  </div>
</div>